import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SectionLabel, SectionHeading } from "./SectionLabel";
import { BRAND_PHOTOS } from "@/config/site";

export default function Strategy() {
  return (
    <section
      id="strategy"
      data-testid="strategy-section"
      className="relative py-24 md:py-32 border-t border-[rgba(198,162,99,0.12)] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <SectionLabel number="02" label="Creative Strategy" />
          <SectionHeading className="mt-6">
            Strategy{" "}
            <span className="italic text-gold-metal">before</span>{" "}
            content.
          </SectionHeading>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[rgb(var(--bone-dim))]">
            Strong content starts with a clear direction. Uberti Creative helps
            brands define their message, organise their visuals, and create
            content that feels consistent, professional, and built for
            attention.
          </p>

          <ul className="mt-8 space-y-3">
            {[
              "Brand positioning & messaging",
              "Content calendars & posting direction",
              "Campaign concepts & visual themes",
              "Profile structure & feed planning",
            ].map((item, i) => (
              <li
                key={item}
                className="flex items-center gap-4 py-3 border-b border-[rgba(198,162,99,0.10)]"
              >
                <span className="font-cinzel text-xs text-[rgb(var(--gold-soft))] w-6">
                  0{i + 1}
                </span>
                <span className="text-[15px] text-[rgb(var(--bone))]">
                  {item}
                </span>
              </li>
            ))}
          </ul>

          <div className="mt-10">
            <a
              href="#contact"
              data-testid="strategy-cta"
              className="inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm font-medium btn-gold"
            >
              Start with Strategy
              <ArrowUpRight size={16} />
            </a>
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative rounded-2xl overflow-hidden border border-[rgba(198,162,99,0.18)] aspect-[5/6]">
            <img
              src={BRAND_PHOTOS.engravedSign}
              alt="Uberti Creative engraved brand sign"
              className="absolute inset-0 w-full h-full object-cover bg-black"
              style={{ objectPosition: "50% 50%" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.7)] via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="text-[11px] tracking-[0.3em] uppercase text-[rgb(var(--gold-soft))]">
                Inside the Studio
              </div>
              <div className="mt-1 font-serif-display italic text-lg text-[rgb(var(--bone))]">
                Plans built before posts.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
